var render, staticRenderFns
import script from "./SparklineWithAverage.vue?vue&type=script&lang=js&"
export * from "./SparklineWithAverage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SparklineWithAverage.vue"
export default component.exports